// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"a96ab228","30":"7ad2269e","762":"4e7623ea","787":"c2c0e3eb"}[chunkId] + ".chunk.js";
};